module.exports = __webpack_public_path__ + "img/estp.797d6c27.png";